/* eslint-disable react/jsx-no-target-blank */
import React, { useEffect, useRef, useState } from 'react';
import { NavLink, useLocation, withRouter } from 'react-router-dom';
import { Navbar, Nav } from 'react-bootstrap';
import { OverlayPanel } from 'primereact/overlaypanel';
import { isEmpty } from 'lodash';
import { Growl } from 'primereact/growl';

import { useNewChatMessage, useUnreadMessageCount, useUser } from '../store/hooks/hooks';
import CONSTANTS from '../constants/constant';
import API from '../services/API';
import { config } from '../config';
import { buildTagUserWithoutHtml, longDateFormat } from '../utilities/common';

import './Header.scss';
import UserProfileIcon from '../statics/images/profile_icon.png';
import Logo from '../statics/images/logo_wobg.png';
// import AudioMessage from '../statics/sounds/new-mess.mp3';

/** Khóa lưu lựa chọn THU GỌN thanh menu trên MÁY NÀY (↔ app `thanh_menu.thu_gon`). */
const THU_GON_MENU_KEY = 'header.thu_gon_menu';

function Header() {
  const [unread, setUnread] = useState<number>(0);
  const [pendingApprovalCount, setPendingApprovalCount] = useState<number>(0);
  const [notifications, setNotifications] = useState<any[]>([]);
  const [unreadNoti, setUnreadNoti] = useState<number>(0);
  const [faultReportUnread, setFaultReportUnread] = useState<number>(0);

  const userProfileRef = useRef<OverlayPanel>(null);
  const matchedOrderRef = useRef<OverlayPanel>(null);
  const growlRef = useRef<Growl>(null);

  const user = useUser();
  const location = useLocation();
  const newChatMessage = useNewChatMessage();
  // Map bộ đếm chưa đọc trong store: trang CHAT ghi vào khi có tin mới, socket middleware ghi
  // vào khi nhận `unread-updated`. Theo dõi ở đây để badge trên thanh tiêu đề không còn đứng
  // im từ lúc mở trang tới lúc F5.
  const unreadMessageCount = useUnreadMessageCount();

  // THU GỌN THANH MENU (giống nút ⌃ / ⌄ trên app desktop, QA 21/10/2026):
  // thu gọn thì thanh menu chỉ cao MỘT dòng (các mục dòng sau bị giấu), rê chuột
  // vào dải menu là bung đủ menu ĐÈ lên nội dung — trang bên dưới không bị đẩy.
  // Chọn mục hoặc đưa chuột ra ngoài là tấm nổi tự thu. Lựa chọn lưu theo MÁY
  // (localStorage) vì là lựa chọn của màn hình/chỗ ngồi, không phải tài khoản.
  const [thuGonMenu, setThuGonMenu] = useState<boolean>(() => {
    try {
      return localStorage.getItem(THU_GON_MENU_KEY) === '1';
    } catch (e) {
      return false;
    }
  });
  const [bungMenu, setBungMenu] = useState<boolean>(false);
  // Ngăn kéo menu ☰ ở màn hẹp (< lg): chạm ra ngoài là đóng. Màn rộng Bootstrap luôn hiện menu nên state này không có tác dụng.
  const [moMenuNho, setMoMenuNho] = useState<boolean>(false);
  const menuDaiRef = useRef<HTMLDivElement>(null);
  const henBungRef = useRef<number | undefined>(undefined);

  const huyHen = () => {
    if (henBungRef.current !== undefined) {
      window.clearTimeout(henBungRef.current);
      henBungRef.current = undefined;
    }
  };

  // Menu vừa một dòng thì thu gọn chẳng giấu gì, không cần bung tấm nổi.
  const coDongBiGiau = () => {
    const nav = menuDaiRef.current?.querySelector('.navbar-nav') as HTMLElement | null;
    return !!nav && nav.scrollHeight > nav.clientHeight + 1;
  };

  // Chờ một nhịp trước khi bung: chuột chỉ lướt ngang qua thanh thì không bật
  // tấm nổi lên che trang.
  const henMoMenu = () => {
    huyHen();
    if (!thuGonMenu || bungMenu) return;
    henBungRef.current = window.setTimeout(() => {
      if (coDongBiGiau()) setBungMenu(true);
    }, 250);
  };

  // Chờ một nhịp trước khi thu: chuột trượt ra mép một chút không làm tấm nổi chớp tắt.
  const henDongMenu = () => {
    huyHen();
    henBungRef.current = window.setTimeout(() => setBungMenu(false), 300);
  };

  const dongMenu = () => {
    huyHen();
    setBungMenu(false);
  };

  const daoThuGonMenu = () => {
    const moi = !thuGonMenu;
    setThuGonMenu(moi);
    dongMenu();
    try {
      localStorage.setItem(THU_GON_MENU_KEY, moi ? '1' : '0');
    } catch (e) {
      // Ghi hỏng thì lựa chọn chỉ sống trong phiên này.
    }
  };

  useEffect(() => huyHen, []);

  const handleShowProfile = (e: any) => {
    if (userProfileRef.current) {
      userProfileRef.current.toggle(e);
    }
  };

  const handleHideProfile = () => {
    if (userProfileRef.current) {
      userProfileRef.current.hide();
    }
  };

  // Sao chép MÃ ĐĂNG NHẬP APP vào clipboard. Trình duyệt cũ / http không có
  // navigator.clipboard nên fallback qua textarea ẩn + execCommand.
  const handleCopyLoginCode = async () => {
    const code = user.app_login_code || '';
    if (isEmpty(code)) return;
    try {
      if (navigator.clipboard) {
        await navigator.clipboard.writeText(code);
      } else {
        const textarea = document.createElement('textarea');
        textarea.value = code;
        textarea.style.position = 'fixed';
        textarea.style.opacity = '0';
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        document.body.removeChild(textarea);
      }
      growlRef.current?.show({
        severity: 'success',
        summary: 'ĐÃ SAO CHÉP MÃ ĐĂNG NHẬP APP',
        detail: code,
        life: 2000,
      });
    } catch (e) {
      growlRef.current?.show({
        severity: 'error',
        summary: 'KHÔNG SAO CHÉP ĐƯỢC MÃ ĐĂNG NHẬP APP',
        life: 3000,
      });
    }
  };

  const handleShowMatching = (e: any) => {
    getNotifications();
    if (matchedOrderRef.current) {
      matchedOrderRef.current.toggle(e);
    }
  };

  const showNewMessage = (groupName: string, message: string) => {
    if (growlRef.current) {
      growlRef.current.show({ severity: 'info', summary: groupName, detail: message });
    }
  };

  // Cộng bộ đếm chưa đọc từ map `/unread-by-group` -> hai con số hiện trên thanh tiêu đề.
  // Tách hàm vì có HAI nguồn dùng chung: lần gọi API lúc mở trang và event socket
  // `unread-updated` (đọc ở tab/thiết bị khác).
  const applyUnreadMessage = (unreadMessage: any) => {
    if (isEmpty(unreadMessage)) {
      return;
    }
    let totalNewMsg = 0;
    let totalNewMsgFaultReport = 0;
    // Xô nào chưa có trong payload thì bỏ qua — ảnh chụp từ server chỉ chứa nhóm còn > 0.
    for (const chatType of ['internal', 'driver', 'ctv', 'customer', 'staff']) {
      for (const groupID of Object.keys(unreadMessage[chatType] || {})) {
        totalNewMsg += Number(unreadMessage[chatType][groupID]) || 0;
      }
    }
    for (const groupID of Object.keys(unreadMessage.fault_report || {})) {
      totalNewMsgFaultReport += Number(unreadMessage.fault_report[groupID]) || 0;
    }
    setUnread(totalNewMsg);
    setFaultReportUnread(totalNewMsgFaultReport);
  };

  const getMessageCount = async () => {
    const result = await API.fetchUnreadMessageCount();
    if (result.success) {
      applyUnreadMessage(result.data);
    }
  };

  const getPendingApprovalCount = async () => {
    const response = await API.getPendingOwnerCount();
    if (response.success) {
      setPendingApprovalCount(response.data);
    }
  };

  const getNotifications = async () => {
    const response = await API.getNotifications();
    if (response.success) {
      setNotifications(response.data);
    }
  };

  const markAsReadNotification = async (id: number) => {
    const response = await API.updateNotificationStatus(id);
    if (response.success) {
      const updatedNotifications = notifications.map((notification) => {
        if (notification.id === id) {
          return { ...notification, is_read: true };
        }
        return notification;
      });
      setNotifications(updatedNotifications);
    }
  };

  useEffect(() => {
    if (!isEmpty(user.message) && growlRef.current) {
      growlRef.current.show({
        severity: 'error',
        summary: user.message,
        life: 4000,
      });
    }
  }, [user.message]);

  useEffect(() => {
    const unreadNotifications = notifications.filter((notification) => !notification.is_read);
    setUnreadNoti(unreadNotifications.length);
  }, [notifications]);

  useEffect(() => {
    getMessageCount();
    getPendingApprovalCount();
    getNotifications();
  }, []);

  useEffect(() => {
    applyUnreadMessage(unreadMessageCount);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [unreadMessageCount]);

  useEffect(() => {
    if (newChatMessage) {
      const msg = JSON.parse(newChatMessage);
      if (msg.message.type === 'text' && msg.message.message !== '') {
        const message = buildTagUserWithoutHtml(msg.message.message);
        const grName = msg.room.name;
        if (msg.room.user_role === 'member' && Number(msg.message.user_id) !== Number(user.id)) {
          showNewMessage(grName, message);
        }
      }
    }
  }, [newChatMessage]);

  return (
    <>
      <Navbar
        className={`header${thuGonMenu ? ' menu-thu-gon' : ''}`}
        expand="lg"
        expanded={moMenuNho}
        onToggle={(moi: boolean) => setMoMenuNho(moi)}
      >
        <Navbar.Brand href="/">
          <img src={Logo} alt="logo" className="logo" />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        {moMenuNho && <div className="menu-nho-nen d-lg-none" onClick={() => setMoMenuNho(false)} />}
        <Navbar.Collapse id="basic-navbar-nav">
          {/* Dải menu: khi THU GỌN chỉ cao một dòng, rê chuột vào là bung tấm nổi
              (class `bung`) đè lên nội dung; bấm chọn mục (chuột trái) là thu lại. */}
          <div
            ref={menuDaiRef}
            className={`menu-dai mr-auto${bungMenu ? ' bung' : ''}`}
            onMouseEnter={henMoMenu}
            onMouseLeave={henDongMenu}
            onClick={(e) => {
              if (e.button === 0 && (e.target as HTMLElement).closest('.nav-link')) dongMenu();
            }}
          >
          <Nav className="mr-auto" activeKey={location.pathname}>
            {/* TIN NHẮN và ĐƠN HÀNG NHANH đứng ĐẦU thanh menu, cùng thứ tự với app
                desktop (QA 21/10/2026) — hai chỗ làm việc nhiều nhất. */}
            {user.hasVicMenu(CONSTANTS.VIC_MENU_OPTIONS.CHAT) && (
              <Nav.Link href={`${config.webChatUrl}/chat`} target="_blank">
                TIN NHẮN
              </Nav.Link>
            )}
            {user.hasVicMenu(CONSTANTS.VIC_MENU_OPTIONS.DON_HANG_NHANH) && (
              <Nav.Link href="/don-hang-nhanh">ĐƠN HÀNG NHANH</Nav.Link>
            )}
            {user.hasVicMenu(CONSTANTS.VIC_MENU_OPTIONS.DS_TAI_XE) && <Nav.Link href="/tai-xe">DS TÀI XẾ</Nav.Link>}
            {/* CHỐNG SPAM OTP không còn nằm ở thanh menu chính — vào từ nút trong DS TÀI XẾ.
                Đường dẫn /chong-spam-otp vẫn sống để dán link cho nhau lúc có sự cố. */}
            {user.hasVicMenu(CONSTANTS.VIC_MENU_OPTIONS.XE_DAT_HANG) && (
              <Nav.Link href="/xe-dat-hang">XE ĐẶT HÀNG</Nav.Link>
            )}
            {user.hasVicMenu(CONSTANTS.VIC_MENU_OPTIONS.DS_CHANH) && <Nav.Link href="/chanh">DS CHÀNH</Nav.Link>}
            {user.hasVicMenu(CONSTANTS.VIC_MENU_OPTIONS.CHANH_DAT_HANG) && (
              <Nav.Link href="/chanh-dat-hang">CHÀNH ĐẶT HÀNG</Nav.Link>
            )}
            {user.hasVicMenu(CONSTANTS.VIC_MENU_OPTIONS.DS_CHU_HANG) && (
              <Nav.Link href="/chu-hang">DS KHÁCH HÀNG</Nav.Link>
            )}
            {user.hasVicMenu(CONSTANTS.VIC_MENU_OPTIONS.CHU_DAT_HANG) && (
              <Nav.Link href="/chu-dat-hang">
                <div className="pending-owner-header">
                  KHÁCH ĐẶT HÀNG
                  {pendingApprovalCount > 0 && <p className="pending-owner-badges">{pendingApprovalCount}</p>}
                </div>
              </Nav.Link>
            )}
            {user.hasVicMenu(CONSTANTS.VIC_MENU_OPTIONS.VAN_HANH_DON_HANG) && (
              <Nav.Link href="/van-hanh">VẬN HÀNH ĐƠN HÀNG</Nav.Link>
            )}
            {user.hasVicMenu(CONSTANTS.VIC_MENU_OPTIONS.VAN_HANH_DON_HANG_PHONG_THAU) && (
              <Nav.Link href="/van-hanh-phong-thau">VẬN HÀNH ĐƠN HÀNG - PHÒNG THẦU</Nav.Link>
            )}
            {(user.hasVicMenu(CONSTANTS.VIC_MENU_OPTIONS.DANH_SACH_VAY_TIEN) ||
              user.hasVicMenu(CONSTANTS.VIC_MENU_OPTIONS.HAN_MUC_CONG_NO)) && (
              <Nav.Link href="/han-muc-cong-no">HẠN MỨC CÔNG NỢ</Nav.Link>
            )}
            {user.hasVicMenu(CONSTANTS.VIC_MENU_OPTIONS.HOP_DONG_DON_HANG) && (
              <Nav.Link href="/hop-dong">HỢP ĐỒNG ĐƠN HÀNG</Nav.Link>
            )}
            {user.hasVicMenu(CONSTANTS.VIC_MENU_OPTIONS.KE_TOAN_CHUNG_TU) && (
              <Nav.Link href="/ke-toan-chung-tu">KẾ TOÁN CHỨNG TỪ</Nav.Link>
            )}
            {user.hasVicMenu(CONSTANTS.VIC_MENU_OPTIONS.THANH_TOAN_CHUYEN_KHOAN) && (
              <Nav.Link href="/thanh-toan">THANH TOÁN CHUYỂN KHOẢN</Nav.Link>
            )}
            {user.hasVicMenu(CONSTANTS.VIC_MENU_OPTIONS.KIEM_SOAT_DON_HANG) && (
              <Nav.Link href="/kiem-soat-dh">KIỂM SOÁT ĐƠN HÀNG</Nav.Link>
            )}
            {user.hasVicMenu(CONSTANTS.VIC_MENU_OPTIONS.THAM_KHAO_GIA) && (
              <Nav.Link href="/tham-khao-gia">THAM KHẢO GIÁ</Nav.Link>
            )}
            {user.hasVicMenu(CONSTANTS.VIC_MENU_OPTIONS.XE_TIM_HANG) && (
              <Nav.Link href="/xe-tim-hang">XE TÌM HÀNG</Nav.Link>
            )}
            {user.hasVicMenu(CONSTANTS.VIC_MENU_OPTIONS.KY_QUY) && <Nav.Link href="/ky-quy">KÝ QUỸ</Nav.Link>}
            {user.hasVicMenu(CONSTANTS.VIC_MENU_OPTIONS.DS_BAO_HIEM) && (
              <Nav.Link href="/bao-hiem">DS BẢO HIỂM</Nav.Link>
            )}
            {user.hasVicMenu(CONSTANTS.VIC_MENU_OPTIONS.CSKH_BAO_HIEM) && (
              <Nav.Link href="/bao-hiem-sap-het-han">CSKH BẢO HIỂM</Nav.Link>
            )}
            {user.hasVicMenu(CONSTANTS.VIC_MENU_OPTIONS.DON_HANG_BAO_HIEM) && (
              <Nav.Link href="/don-hang-bao-hiem">ĐƠN HÀNG BẢO HIỂM</Nav.Link>
            )}
            {/* <Nav.Link href="/tk-txe">APP TÀI XẾ</Nav.Link>
          <Nav.Link href="/tk-ch">APP CHỦ HÀNG</Nav.Link> */}
            {user.hasVicMenu(CONSTANTS.VIC_MENU_OPTIONS.PHAN_VIEC_CHU_HANG) && (
              <Nav.Link href="/phan-viec-chu-hang">PHÂN VIỆC KHÁCH HÀNG (CŨ)</Nav.Link>
            )}
            {user.hasVicMenu(CONSTANTS.VIC_MENU_OPTIONS.PHAN_VIEC_KHACH_HANG) && (
              <Nav.Link href="/phan-viec-khach-hang">PHÂN VIỆC KHÁCH HÀNG</Nav.Link>
            )}
            {user.hasVicMenu(CONSTANTS.VIC_MENU_OPTIONS.PHAN_VIEC_TAI_XE_MOI) && (
              <Nav.Link href="/phan-viec-tai-xe">PHÂN VIỆC TÀI XẾ</Nav.Link>
            )}
            {/* <Nav.Link href="/phan-viec-tai-xe-cu">PHÂN VIỆC TÀI XẾ (CŨ)</Nav.Link> */}
            {user.hasVicMenu(CONSTANTS.VIC_MENU_OPTIONS.TH_GIAN_LAM_VIEC) && (
              <Nav.Link href="/working-time">TH/GIAN LÀM VIỆC</Nav.Link>
            )}
            {user.hasVicMenu(CONSTANTS.VIC_MENU_OPTIONS.TARGET_DOANH_SO) && (
              <Nav.Link href="/target-doanh-so">TARGET DOANH SỐ</Nav.Link>
            )}
            {user.hasVicMenu(CONSTANTS.VIC_MENU_OPTIONS.EXECUTE_THE_PLAN) && (
              <Nav.Link href="/execute-the-plan">
                <div className="pending-owner-header">
                  EXECUTE THE PLAN
                  {faultReportUnread > 0 && <p className="pending-owner-badges">{faultReportUnread}</p>}
                </div>
              </Nav.Link>
            )}
            {user.hasVicMenu(CONSTANTS.VIC_MENU_OPTIONS.NGANH_HANG_PHU_TRO) && (
              <Nav.Link href="/nganh-hang-phu-tro">TIỆN ÍCH HỖ TRỢ</Nav.Link>
            )}
            {user.hasVicMenu(CONSTANTS.VIC_MENU_OPTIONS.QUAN_LY_FILE) && (
              <Nav.Link href="/quan-ly-file">QUẢN LÝ FILE</Nav.Link>
            )}
            {user.hasProject(CONSTANTS.PROJECTS.PROJECT_ONE) && (
              <Nav.Link href="/projectone" id="header-project-one">
                PROJECT ONE
              </Nav.Link>
            )}
            {user.hasVicMenu(CONSTANTS.VIC_MENU_OPTIONS.LANDING_PAGE) && (
              <Nav.Link href="/landing-page" id="header-landing-page">
                LANDING PAGE
              </Nav.Link>
            )}
            {user.hasVicMenu(CONSTANTS.VIC_MENU_OPTIONS.KHAO_SAT) && (
              <Nav.Link href="/khao-sat" id="header-khao-sat">
                KHẢO SÁT NHÂN VIÊN
              </Nav.Link>
            )}
            {user.hasVicMenu(CONSTANTS.VIC_MENU_OPTIONS.DANH_GIA_VIC_AI) && (
              <Nav.Link href="/danh-gia-vic-ai" id="header-danh-gia-vic-ai">
                ĐÁNH GIÁ VIC AI
              </Nav.Link>
            )}
            {user.hasVicMenu(CONSTANTS.VIC_MENU_OPTIONS.QUAN_LY_TAI_XE) && (
              <Nav.Link href="/quan-ly-tai-xe" id="header-quan-ly-tai-xe">
                QUẢN LÝ XE
              </Nav.Link>
            )}
            {user.hasVicMenu(CONSTANTS.VIC_MENU_OPTIONS.DON_HANG_NHANH_TEST) && (
              <Nav.Link href="/don-hang-nhanh-test">ĐƠN HÀNG NHANH TEST</Nav.Link>
            )}
            {user.hasVicMenu(CONSTANTS.VIC_MENU_OPTIONS.DON_HANG_NHANH_TEST) && (
              <Nav.Link href="/quan-ly-don-test">QUẢN LÝ ĐƠN TEST</Nav.Link>
            )}
            {user.hasVicMenu(CONSTANTS.VIC_MENU_OPTIONS.XU_LY_VAN_BAN) && (
              <Nav.Link href="/xu-ly-van-ban">XỬ LÝ VĂN BẢN</Nav.Link>
            )}
            <Nav.Item className="d-block d-lg-none">
              <hr />
            </Nav.Item>
            {user.hasVicMenu(CONSTANTS.VIC_MENU_OPTIONS.BAO_CAO_THONG_KE_CONG_VIEC) && (
              <Nav.Link href="/thong-ke" className="d-block d-lg-none">
                BÁO CÁO THỐNG KÊ CÔNG VIỆC
              </Nav.Link>
            )}
            {user.hasRole(CONSTANTS.PPKD_ROLES.XEM_THONG_KE_CUOC_GOI) && (
              <>
                <Nav.Link href="/tk-cuoc-goi" className="d-block d-lg-none">
                  BÁO CÁO THỐNG KÊ CUỘC GỌI
                </Nav.Link>
              </>
            )}
            {user.hasVicMenu(CONSTANTS.VIC_MENU_OPTIONS.LICH_LAM_VIEC) && (
              <Nav.Link href="/lich-lam-viec" className="d-block d-lg-none">
                LỊCH LÀM VIỆC
              </Nav.Link>
            )}
            {(user.hasRole(CONSTANTS.SYSTEM_ROLES.QUAN_LY_GIO_CONG) || user.hasSalaryRole()) && (
              <>
                <Nav.Link href="/admin-working-time" className="d-block d-lg-none">
                  QUẢN LÝ GIỜ CÔNG VÀ BẢNG LƯƠNG
                </Nav.Link>
              </>
            )}
            {user.hasRole(CONSTANTS.MANAGEMENT_ROLES.DUA_SDT_NHAN_VIEN_LEN_TREN_APP) && (
              <Nav.Link href="/app-phones" className="d-block d-lg-none">
                QUẢN LÝ SỐ ĐIỆN THOẠI TRÊN APP
              </Nav.Link>
            )}
            {user.isAdmin() && (
              <Nav.Link href="/tk-web" className="d-block d-lg-none">
                QUẢN LÝ TÀI KHOẢN WEB
              </Nav.Link>
            )}
            {(user.hasRole(CONSTANTS.BANK_STATISTIC_ROLES.XEM_SO_DU_NGAN_HANG) ||
              user.hasRole(CONSTANTS.BANK_STATISTIC_ROLES.XEM_THANH_TOAN_HOAN_THANH_DON)) && (
              <Nav.Link href="/so-du-ngan-hang" className="d-block d-lg-none">
                QUẢN LÝ SỐ DƯ NGÂN HÀNG
              </Nav.Link>
            )}
            {user.hasVicMenu(CONSTANTS.VIC_MENU_OPTIONS.PHAP_CHE) && (
              <Nav.Link href="/phap-che" className="d-block d-lg-none">
                PHÁP CHẾ
              </Nav.Link>
            )}
            {(user.hasRole(CONSTANTS.SECRETARY_ROLES.QUAN_LY_KE_TOAN) ||
              user.hasRole(CONSTANTS.SECRETARY_ROLES.QUYEN_DUYET_CHI_TIEN_GDDA) ||
              user.hasRole(CONSTANTS.SECRETARY_ROLES.QUYEN_DUYET_CHI_TIEN_KTNB) ||
              user.hasRole(CONSTANTS.SECRETARY_ROLES.QUYEN_DUYET_CHI_TIEN_KTT) ||
              user.hasRole(CONSTANTS.SECRETARY_ROLES.QUYEN_DUYET_CHI_TIEN_TPKD)) && (
              <Nav.Link href="/ke-toan-chi" className="d-block d-lg-none">
                TOÁN CHI
              </Nav.Link>
            )}
            {user.hasRole(CONSTANTS.CHAT_ROLES.QUAN_LY_NHOM_CHAT_NOI_BO) && (
              <Nav.Link href="/quan-ly-nhom-chat" className="d-block d-lg-none">
                QUẢN LÝ NHÓM CHAT
              </Nav.Link>
            )}
            {user.hasRole(CONSTANTS.MANAGEMENT_ROLES.CAI_DAT_PHAN_DON) && (
              <Nav.Link href="/cai-dat-phan-don" className="d-block d-lg-none">
                CÀI ĐẶT PHÂN CHIA ĐƠN HÀNG
              </Nav.Link>
            )}
            {user.isAdmin() && (
              <Nav.Link href="/tai-khoan-cty" className="d-block d-lg-none">
                QUẢN LÝ TÀI KHOẢN NGÂN HÀNG
              </Nav.Link>
            )}
            {user.hasRole(CONSTANTS.SYSTEM_ROLES.CAI_DAT_KHAO_SAT_NHAN_VIEN) && (
              <Nav.Link href="/cai-dat-khao-sat" className="d-block d-lg-none">
                CÀI ĐẶT KHẢO SÁT NHÂN VIÊN
              </Nav.Link>
            )}
            {user.hasVicMenu(CONSTANTS.VIC_MENU_OPTIONS.HANG_MUC_AI) && (
              <Nav.Link href="/hang-muc-ai" className="d-block d-lg-none">
                HẠNG MỤC AI
              </Nav.Link>
            )}
            <Nav.Link href="/profile" className="d-block d-lg-none">
              TÀI KHOẢN
            </Nav.Link>
            <Nav.Link href="/logout" className="d-block d-lg-none">
              ĐĂNG XUẤT
            </Nav.Link>
          </Nav>
          </div>
          {/* Nút ⌃ / ⌄ thu gọn / mở rộng thanh menu — chỉ có ở màn rộng (≥ lg), màn
              hẹp menu đã nằm trong nút ☰ của Bootstrap. */}
          <button
            type="button"
            className="menu-thu-gon-nut d-none d-lg-inline-flex"
            title={thuGonMenu ? 'Luôn hiện đầy đủ menu' : 'Thu gọn menu còn 1 dòng\nRê chuột vào menu để xem đủ'}
            aria-label={thuGonMenu ? 'Mở rộng menu' : 'Thu gọn menu'}
            onClick={daoThuGonMenu}
          >
            <i className={`pi ${thuGonMenu ? 'pi-angle-down' : 'pi-angle-up'}`} />
          </button>
        </Navbar.Collapse>
        {user && !isEmpty(user.token) ? (
          <div className="app-login-info">
            <div className="app-icons">
              <div className="notification-icon d-none d-lg-block">
                <span className="pi pi-bell" onClick={handleShowMatching}>
                  {unreadNoti > 0 && <span className="noti-badges">{unreadNoti}</span>}
                </span>
              </div>
              <div className="chats-icon d-none d-lg-block">
                <a className="pi pi-comments" href={`${config.webChatUrl}/chat`} target="_blank">
                  {unread > 0 && <span className="chat-badges">{unread > 99 ? '99+' : unread}</span>}
                </a>
              </div>
              <div className="user-profile-icon d-none d-lg-block" id="user">
                <span onClick={handleShowProfile}>
                  <img src={UserProfileIcon} alt="profile" />
                </span>
              </div>
            </div>
            {!isEmpty(user.app_login_code) && (
              <div className="app-login-code mt-4">
                <div className="text-center">MÃ ĐĂNG NHẬP APP</div>
                <div className="login-code-value">
                  <h2 className="text-primary">{user.app_login_code}</h2>
                  <span className="copy-login-code" title="Sao chép mã đăng nhập" onClick={handleCopyLoginCode}>
                    <i className="pi pi-copy" />
                  </span>
                </div>
              </div>
            )}
            <OverlayPanel ref={userProfileRef} appendTo={document.body} className="user-profile-overlay">
              <div className="menu-header wrap-text">{user.email}</div>
              <div className="menu-item">
                <NavLink to="/thong-ke" className="item-group" onClick={handleHideProfile}>
                  <i className="pi pi-briefcase" />
                  <span>BÁO CÁO THỐNG KÊ CÔNG VIỆC</span>
                </NavLink>
              </div>
              {user.hasRole(CONSTANTS.PPKD_ROLES.XEM_THONG_KE_CUOC_GOI) && (
                <div className="menu-item">
                  <NavLink to="/tk-cuoc-goi" className="item-group" onClick={handleHideProfile}>
                    <i className="pi pi-list" />
                    <span>BÁO CÁO THỐNG KÊ CUỘC GỌI</span>
                  </NavLink>
                </div>
              )}
              {user.hasVicMenu(CONSTANTS.VIC_MENU_OPTIONS.LICH_LAM_VIEC) && (
                <div className="menu-item">
                  <NavLink to="/lich-lam-viec" className="item-group" onClick={handleHideProfile}>
                    <i className="pi pi-calendar" />
                    <span>LỊCH LÀM VIỆC</span>
                  </NavLink>
                </div>
              )}
              {(user.hasRole(CONSTANTS.SYSTEM_ROLES.QUAN_LY_GIO_CONG) || user.hasSalaryRole()) && (
                <>
                  <div className="menu-item">
                    <NavLink to="/admin-working-time" className="item-group" onClick={handleHideProfile}>
                      <i className="pi pi-clock" />
                      <span>QUẢN LÝ GIỜ CÔNG VÀ BẢNG LƯƠNG</span>
                    </NavLink>
                  </div>
                </>
              )}
              {user.isAdmin() && (
                <>
                  <div className="menu-item">
                    <NavLink to="/tk-web" className="item-group" onClick={handleHideProfile}>
                      <i className="pi pi-user" />
                      <span>QUẢN LÝ TÀI KHOẢN WEB</span>
                    </NavLink>
                  </div>
                </>
              )}
              {(user.hasRole(CONSTANTS.BANK_STATISTIC_ROLES.XEM_SO_DU_NGAN_HANG) ||
                user.hasRole(CONSTANTS.BANK_STATISTIC_ROLES.XEM_THANH_TOAN_HOAN_THANH_DON)) && (
                <div className="menu-item">
                  <NavLink to="/so-du-ngan-hang" className="item-group" onClick={handleHideProfile}>
                    <i className="pi pi-money-bill" />
                    <span>QUẢN LÝ SỐ DƯ NGÂN HÀNG</span>
                  </NavLink>
                </div>
              )}
              <div className="menu-item">
                <NavLink to="/phap-che" className="item-group" onClick={handleHideProfile}>
                  <i className="pi pi-lock" />
                  <span>PHÁP CHẾ</span>
                </NavLink>
              </div>
              {(user.hasRole(CONSTANTS.SECRETARY_ROLES.QUAN_LY_KE_TOAN) ||
                user.hasRole(CONSTANTS.SECRETARY_ROLES.QUYEN_DUYET_CHI_TIEN_GDDA) ||
                user.hasRole(CONSTANTS.SECRETARY_ROLES.QUYEN_DUYET_CHI_TIEN_KTNB) ||
                user.hasRole(CONSTANTS.SECRETARY_ROLES.QUYEN_DUYET_CHI_TIEN_KTT) ||
                user.hasRole(CONSTANTS.SECRETARY_ROLES.QUYEN_DUYET_CHI_TIEN_TPKD)) && (
                <div className="menu-item">
                  <NavLink to="/ke-toan-chi" className="item-group" onClick={handleHideProfile}>
                    <i className="pi pi-money-bill" />
                    <span>KẾ TOÁN CHI</span>
                  </NavLink>
                </div>
              )}
              {user.hasRole(CONSTANTS.CHAT_ROLES.QUAN_LY_NHOM_CHAT_NOI_BO) && (
                <div className="menu-item">
                  <NavLink to="/quan-ly-nhom-chat" className="item-group" onClick={handleHideProfile}>
                    <i className="pi pi-cloud" />
                    <span>QUẢN LÝ NHÓM CHAT</span>
                  </NavLink>
                </div>
              )}
              {user.hasRole(CONSTANTS.MANAGEMENT_ROLES.CAI_DAT_PHAN_DON) && (
                <div className="menu-item">
                  <NavLink to="/cai-dat-phan-don" className="item-group" onClick={handleHideProfile}>
                    <i className="pi pi-comments" />
                    <span>CÀI ĐẶT PHÂN CHIA ĐƠN HÀNG</span>
                  </NavLink>
                </div>
              )}
              {user.hasRole(CONSTANTS.MANAGEMENT_ROLES.DUA_SDT_NHAN_VIEN_LEN_TREN_APP) && (
                <div className="menu-item">
                  <NavLink to="/app-phones" className="item-group" onClick={handleHideProfile}>
                    <i className="pi pi-mobile" />
                    <span>QUẢN LÝ SỐ ĐIỆN THOẠI TRÊN APP</span>
                  </NavLink>
                </div>
              )}
              {user.isAdmin() && (
                <div className="menu-item">
                  <NavLink to="/tai-khoan-cty" className="item-group" onClick={handleHideProfile}>
                    <i className="pi pi-briefcase" />
                    <span>QUẢN LÝ TÀI KHOẢN NGÂN HÀNG</span>
                  </NavLink>
                </div>
              )}
              {user.hasVicMenu(CONSTANTS.VIC_MENU_OPTIONS.HANG_MUC_AI) && (
                <div className="menu-item">
                  <NavLink to="/hang-muc-ai" className="item-group" onClick={handleHideProfile}>
                    <i className="pi pi-list" />
                    <span>HẠNG MỤC AI</span>
                  </NavLink>
                </div>
              )}
              {user.hasRole(CONSTANTS.SYSTEM_ROLES.CAI_DAT_KHAO_SAT_NHAN_VIEN) && (
                <div className="menu-item">
                  <NavLink to="/cai-dat-khao-sat" className="item-group" onClick={handleHideProfile}>
                    <i className="pi pi-list" />
                    <span>CÀI ĐẶT KHẢO SÁT NHÂN VIÊN</span>
                  </NavLink>
                </div>
              )}
              {user.hasRole(CONSTANTS.SYSTEM_ROLES.CAI_DAT_PHAN_QUYEN) && (
                <div className="menu-item">
                  <NavLink to="/cai-dat-phan-quyen" className="item-group" onClick={handleHideProfile}>
                    <i className="pi pi-users" />
                    <span>CÀI ĐẶT PHÂN QUYỀN</span>
                  </NavLink>
                </div>
              )}
              {user.hasVicMenu(CONSTANTS.VIC_MENU_OPTIONS.THEO_DOI_HE_THONG) && (
                <div className="menu-item">
                  <NavLink to="/system-health" className="item-group" onClick={handleHideProfile}>
                    <i className="pi pi-chart-bar" />
                    <span>THEO DÕI HỆ THỐNG</span>
                  </NavLink>
                </div>
              )}
              {user.hasVicMenu(CONSTANTS.VIC_MENU_OPTIONS.THEO_DOI_AI_SERVER) && (
                <div className="menu-item">
                  <NavLink to="/ai-server" className="item-group" onClick={handleHideProfile}>
                    <i className="pi pi-chart-bar" />
                    <span>THEO DÕI AI SERVER</span>
                  </NavLink>
                </div>
              )}
              {user.hasVicMenu(CONSTANTS.VIC_MENU_OPTIONS.LICH_BOT_CHAY) && (
                <div className="menu-item">
                  <NavLink to="/lich-bot" className="item-group" onClick={handleHideProfile}>
                    <i className="pi pi-clock" />
                    <span>LỊCH BOT CHẠY</span>
                  </NavLink>
                </div>
              )}
              {user.hasVicMenu(CONSTANTS.VIC_MENU_OPTIONS.VAN_PHONG_3D) && (
                <div className="menu-item">
                  <NavLink to="/van-phong" className="item-group" onClick={handleHideProfile}>
                    <i className="pi pi-th-large" />
                    <span>VĂN PHÒNG 3D</span>
                  </NavLink>
                </div>
              )}
              <div className="menu-item">
                <NavLink to="/profile" className="item-group" onClick={handleHideProfile}>
                  <i className="pi pi-user" />
                  <span>TÀI KHOẢN</span>
                </NavLink>
              </div>
              <div className="menu-item">
                <NavLink to="/logout" className="item-group" onClick={handleHideProfile}>
                  <i className="pi pi-sign-out" />
                  <span>ĐĂNG XUẤT</span>
                </NavLink>
              </div>
            </OverlayPanel>
            <OverlayPanel ref={matchedOrderRef} appendTo={document.body} className="notification-overlay">
              <div className="notification-container">
                {notifications.map((notification, index) => (
                  <div
                    key={index}
                    className={`notification-item ${notification.is_read ? '' : 'unread'}`}
                    onClick={() => markAsReadNotification(notification.id)}
                  >
                    <p className="notification-content">{notification.content}</p>
                    <small className="notification-time text-primary">{longDateFormat(notification.created_at)}</small>
                  </div>
                ))}
              </div>
            </OverlayPanel>
            <Growl ref={growlRef} />
          </div>
        ) : (
          <>
            <NavLink to="/login" className="login-btn fsi-14 mr-20">
              <i className="pi pi-sign-in" />
              <span className="pl-8">Đăng nhập</span>
            </NavLink>
          </>
        )}
      </Navbar>
    </>
  );
}

export default withRouter(Header);
